"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importStar(require("react"));
var carousel_item_module_scss_1 = __importDefault(require("./carousel-item.module.scss"));
var TAB_KEY = 'Tab';
var CarouselItem = function (_a) {
    var item = _a.item, index = _a.index, itemsCount = _a.itemsCount, handleKeyUp = _a.handleKeyUp, itemNumber = _a.itemNumber;
    var listItemRef = (0, react_1.useRef)(null);
    var handleKeyUpOnItem = function (event) {
        if (event.key === TAB_KEY) {
            var pageNumber = getPageNumberAttribute(listItemRef.current);
            handleKeyUp(pageNumber);
        }
    };
    var getPageNumberAttribute = function (listItem) {
        return (listItem === null || listItem === void 0 ? void 0 : listItem.dataset.pagenumber) ? +listItem.dataset.pagenumber : NaN;
    };
    return (
    // eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions, jsx-a11y/no-redundant-roles
    react_1.default.createElement("div", { className: (0, classnames_1.default)(carousel_item_module_scss_1.default['carousel-item']), "aria-roledescription": "slide", "aria-label": "".concat(itemNumber, " of ").concat(itemsCount), "data-index": index, role: "listitem", "data-testid": "item-".concat(itemNumber), onKeyUp: handleKeyUpOnItem }, item));
};
exports.default = CarouselItem;
//# sourceMappingURL=CarouselItem.js.map